import {
	type RankingListReportsData,
	rankingGetReport,
	rankingListReports
} from '@repo/sdk/gen'
import { queryOptions } from '@tanstack/react-query'
import { makeQueryKeys } from '@/query/query-keys'

// The reports name the students they are about: every fetch is recorded in the
// event log as an access (decision D37). They keep the client defaults, so a
// page opening is one access, not one per focus.

/** The reports of the students on the ranking of a residence of the manager, open or closed. */
export function rankingReportsQueryOptions(
	residenceId: string,
	state: NonNullable<RankingListReportsData['body']['data']['state']>,
	callId?: string
) {
	return queryOptions({
		queryKey: makeQueryKeys.ranking.reports(residenceId, state, callId),
		queryFn: async ({ signal }) =>
			(
				await rankingListReports({
					body: { data: { residenceId, callId, state } },
					signal
				})
			).data
	})
}

/** One report with the candidate and the facts that may close it. */
export function rankingReportQueryOptions(
	residenceId: string,
	reportId: string
) {
	return queryOptions({
		queryKey: makeQueryKeys.ranking.report(residenceId, reportId),
		queryFn: async ({ signal }) =>
			(
				await rankingGetReport({
					body: { data: { residenceId, reportId } },
					signal
				})
			).data
	})
}
